import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SurveyEntity } from '@mysrc/app/models/surveyEntity';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { data } from 'jquery';
import { Observable } from 'rxjs';
import { EncrDecrService } from '../../../../Providers/EncrDecrService';
import { API_ENDPOINTS } from '../../../../api-endpoints';
import { BaseHttpReqRespService } from '../../../../modules/fwcore/services';
import { CommonService } from '../../../question/services/commonservice';

@Injectable({
  providedIn: 'root'
})

export class SurveyService extends BaseHttpReqRespService {
  workSpaceid: string = "";
  userId: string = "";
  companyId: string = "-1";
  myAppUrl: any;
  public headers!: Headers;
  options: any
  SURVEY_ENDPOINT = API_ENDPOINTS.SURVEY;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  QUESTION_MATRIX_ENDPOINT = API_ENDPOINTS.QUESTION_MATRIX;
  constructor(http: HttpClient
    , @Inject(OKTA_AUTH) private oauth: OktaAuth
    , private EncrDecr: EncrDecrService
    , private commonService: CommonService
    , @Inject('CONFIG_SETTINGS') configSettings: any) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
    this.myAppUrl = this.baseUrl + '/';

    this.getPreRequistics();
  }
  getPreRequistics() {
    this.workSpaceid = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? ""),
      this.userId = this.EncrDecr.get(localStorage.getItem('userId') ?? ""),
      this.companyId = this.EncrDecr.get(localStorage.getItem('companyId') ?? "-1")
    if (this.companyId == "") {
      this.companyId = "-1";
    }

    this.options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

  }

  copySurvey(data: any): Observable<any> {

    const params = new URLSearchParams({
      workSpaceid: this.workSpaceid,
      userId: this.userId,
      companyId: this.companyId
    }).toString();

    const parms = `?${params}`;

    return this.http.post<any>(this.myAppUrl + this.SURVEY_ENDPOINT.COPY + parms, data, this.options);
  }

  updateSurveyResponse(surveyId: any, serviceLineId: any, userId: any): Observable<any> {

    const params = new URLSearchParams({
      surveyId: surveyId,
      serviceLineId: serviceLineId,
      companyId: this.companyId,
      userId: userId
    }).toString();

    const parms = `?${params}`;
    return this.http.post<any>(this.myAppUrl + this.SURVEY_ENDPOINT.UPDATE_SURVEY_RESPONSE + parms, data, this.options);
  }
  getQuestionLanguageSettings(): Observable<any> {
    return this.http.post<any>(this.myAppUrl + this.QUESTION_ENDPOINT.LANGUAGE_SETTINGS, data, this.options);
  }

  getSurveyMessages(serviceLineId: any, surveyId: any): Observable<any> {
    const params = new URLSearchParams({
      serviceLineId: serviceLineId,
      companyId: this.companyId,
      SurveyId: surveyId,
    }).toString();

    const parms = `?${params}`;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.SURVEY_MESSAGES + parms);
  }
  getSurveyMessagesAndLanguages(languageCode: string): Observable<SurveyEntity.SurveyMessageAndLanguage[]> {
    const parms = `?languageCode=${languageCode}`;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.SURVEY_MESSAGES_AND_LANGUAGES + parms);
  }
  getSurveyLanguages(): Observable<SurveyEntity.Language[]> {
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.LANGUAGES);
  }

  getSurveySchema(surveyId: any, serviceLineId: any, isPreview: any, companyId: any): Observable<any> {
    const params = new URLSearchParams({
      surveyId: surveyId,
      serviceLineId: serviceLineId,
      companyId: companyId,
      isPreview: isPreview,
      userId: this.userId,
    }).toString();

    const parms = `?${params}`;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.SURVEY_SCHEMA + parms);


  }
  getWorkspaceId(): Observable<number> {
    var param = '?hostName=' + this.myAppUrl;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.GET_WORKSPACE_ID + param);
  }
  getSurveyProviderLanguageMappedDetails(surveyId: string, serviceLineId: string, companyId: string): Observable<any> {
    const params = new URLSearchParams({
      surveyId: surveyId,
      serviceLineId: serviceLineId,
      companyId: companyId
    }).toString();

    const parms = `?${params}`;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.LANGUAGE_MAPPED_DETAILS + parms);
  }
  deleteSurvey(currentDeletingSurveyId: any): Observable<any> {
    const params = new URLSearchParams({
      surveyId: currentDeletingSurveyId,
      workSpaceid: this.workSpaceid,
      companyId: this.companyId
    }).toString();
    const parms = `?${params}`;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.DELETE + parms);
  }
  getSurveyList(): Observable<any> {
    const params = new URLSearchParams({
      workSpaceid: this.workSpaceid,
      companyId: this.companyId,
    }).toString();
    const parms = `?${params}`;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.SURVEY_LIST + parms);

  }
  getAllSectionConfiguration(surveyId: string): Observable<any> {
    let parameter = "?surveyId=" + surveyId;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.SECTION_CONFIG + parameter);

  }
  getUIConfiguration(surveyId: string): Observable<any> {
    let parameter = "?ConfigurationIdentifierID=" + surveyId;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.UI_ATTRIBUTE_BY_ID + parameter);

  }
  getProgressBarConfiguration(surveyId: string): Observable<any> {
    let parameter = "?surveyId=" + surveyId;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.PROGRESS_BAR_CONFIG + parameter);
  }
  getCompanyLogo(serviceLineId: string, surveyId: string): Observable<SurveyEntity.Company> {
    const params = new URLSearchParams({
      companyId: this.companyId,
      serviceLineId: serviceLineId,
      surveyId: surveyId,
    }).toString();
    const parms = `?${params}`;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.COMPANY_LOGO + parms);

  }
  getQuestionMatrixConditionalSettings(surveyId: any): Observable<any> {
    const parms = `?surveyId=${surveyId}`;
    return this.commonService.httpGet("", this.myAppUrl + this.QUESTION_MATRIX_ENDPOINT.SURVEY_MATRIX_CONDITIONAL_SETTINGS + parms);
  }
  getAdaptiveAssessmentSettings(surveyId: any): Observable<any> {
    const parms = `?surveyId=${surveyId}`;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.ADAPTIVE_ASSSESMENT_SETTINGS + parms);
  }
  getOptionAndSectionSettings(surveyId: any): Observable<any> {
    const parms = `?surveyId=${surveyId}`;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.OPTION_SECTION_SETTINGS + parms);
  }
  getMergeCodeSettings(surveyId: any): Observable<any> {
    const parms = `?surveyId=${surveyId}`;
    return this.commonService.httpGet("", this.myAppUrl + this.SURVEY_ENDPOINT.MERGE_CODE_SETTINGS + parms);
  }
}
